// Fragment "pathwaysWorkspace": the practitioner's side of Pathways v3 (contract §9), part
// 3: the tracking dashboard (admin/pathways/PathwayDashboard.jsx, FunnelChart.jsx,
// EncourageModal.jsx), the phase-3 review queue and attendance (admin/pathways/ReviewQueue.jsx,
// AttendancePanel.jsx, contract §10.11), the weekly prompts (admin/pathways/PromptsPanel.jsx), the learner
// preview (admin/pathways/PathwayPreview.jsx) and the Pathways tab of a CRM contact
// (admin/crm/ContactPathways.jsx, mounted by the CRM's client detail page).
// `path.dash.encourageDefault` is the pre-written encouragement of contract §5.1: the
// practitioner edits it before it is sent. Merged in ./index.js.
export default {
  fr: {
    // ── dashboard ──
    "path.dash.export": "Exporter",
    "path.dash.exportFailed": "L'export n'a pas pu être téléchargé.",
    "path.dash.summary": "Résumé",
    "path.dash.total.enrolled": "Inscrits",
    "path.dash.total.active_this_week": "Actifs cette semaine",
    "path.dash.total.completed": "Terminé",
    "path.dash.total.average_progress": "Progression moyenne",
    "path.dash.total.stuck": "Bloqués (14 j et plus)",
    "path.dash.funnel": "Entonnoir des étapes",
    "path.dash.funnelEmpty": "Ajoutez des étapes pour voir où les apprenants s'arrêtent.",
    "path.dash.funnelSrOne": "{n} apprenant",
    "path.dash.funnelSr": "{n} apprenants",
    "path.dash.funnelDropSrOne": "{n} apprenant, la plus forte baisse",
    "path.dash.funnelDropSr": "{n} apprenants, la plus forte baisse",
    "path.dash.enrolled": "Inscrits",
    "path.dash.learners": "Apprenants",
    "path.dash.filter": "Filtrer les apprenants",
    "path.dash.filterAll": "Tous les apprenants",
    "path.dash.filterStuck": "Bloqués · {n}",
    "path.dash.encourage": "Envoyer un encouragement",
    "path.dash.noLearners": "Aucun apprenant ici pour l'instant.",
    "path.dash.col.name": "Nom",
    "path.dash.col.step": "Étape en cours",
    "path.dash.col.progress": "Progression",
    "path.dash.col.lastActive": "Dernière activité",
    "path.dash.col.quiz": "Moyenne quiz",
    "path.dash.completed": "Terminé",
    "path.dash.progressOf": "Progression de {name}",
    "path.dash.rowHint": "Cliquez sur une ligne pour ouvrir la fiche CRM, onglet Parcours, avec tout l'historique des étapes.",
    "path.review.title": "File de relecture · {n}",
    "path.review.empty": "Aucun envoi en attente.",
    "path.review.who": "{name} · {step}",
    "path.review.quote": "« {text} »",
    "path.review.photoAlt": "Photo envoyée par {name}",
    "path.review.approve": "Approuver",
    "path.review.sendFeedback": "Envoyer un retour",
    "path.review.approved": "Envoi de {name} approuvé",
    "path.review.feedbackSent": "Retour envoyé à {name}",
    "path.review.feedbackTitle": "Retour à {name}",
    "path.review.feedbackHint": "Sur « {step} ». Votre message est envoyé par e-mail et affiché sur l'étape ; l'étape reste validée.",
    "path.review.feedbackMessage": "Message",
    "path.review.feedbackEmpty": "Écrivez un message avant d'envoyer.",
    "path.review.feedbackSend": "Envoyer le retour",
    "path.attendance.title": "Présence · {title} · {when}",
    "path.attendance.titleNoTime": "Présence · {title}",
    "path.attendance.hint": "Après la séance, cochez qui était présent : cela valide l'étape. Décocher retire la présence, sans annuler une étape validée.",
    "path.attendance.save": "Enregistrer la présence",
    "path.attendance.saved": "Présence enregistrée",
    "path.dash.encourageTitle": "Envoyer un encouragement",
    "path.dash.encourageToOne": "À {n} apprenant bloqué : {names}",
    "path.dash.encourageTo": "À {n} apprenants bloqués : {names}",
    "path.dash.encourageMessage": "Message",
    "path.dash.encourageDefault": "Bonjour,\n\nCela fait un moment ! Votre prochaine étape vous attend : reprenez là où vous vous étiez arrêté, à votre rythme. Je suis là si vous avez la moindre question.",
    "path.dash.encourageEmpty": "Écrivez un message avant d'envoyer.",
    "path.dash.encourageSend": "Envoyer à {n}",
    "path.dash.encourageSentOne": "Encouragement envoyé à {n} apprenant.",
    "path.dash.encourageSent": "Encouragement envoyé à {n} apprenants.",
    "path.dash.encourageSentSkipped": "Encouragement envoyé : {sent}. Ignorés : {skipped} (plus inscrits ou déjà terminé).",

    // ── weekly prompts ──
    "path.prompts.title": "Messages hebdomadaires",
    "path.prompts.hint": "Publiés sur la page du parcours de chaque membre et envoyés par e-mail à ceux qui les acceptent.",
    "path.prompts.label": "Nouveau message",
    "path.prompts.placeholder": "Ex. : Cette semaine, observez votre respiration avant chaque pratique…",
    "path.prompts.post": "Publier",
    "path.prompts.empty": "Écrivez le message avant de le publier.",
    "path.prompts.none": "Aucun message publié pour l'instant.",
    "path.prompts.week": "Semaine {n}",

    // ── preview ──
    "path.preview.banner": "Aperçu apprenant : tout est débloqué, et rien n'est enregistré.",
    "path.preview.back": "Retour à la création",

    // ── CRM contact ──
    "path.crm.tabs": "Détails du contact",
    "path.crm.tab": "Parcours",
    "path.crm.empty": "Ce contact n'est inscrit à aucun parcours.",
    "path.crm.submission.pending": "Envoi du {date} · à relire",
    "path.crm.submission.approved": "Envoi du {date} · approuvé",
    "path.crm.submission.feedback_sent": "Envoi du {date} · retour envoyé",
    "path.crm.submission.superseded": "Envoi du {date} · remplacé",
    "path.crm.attended": "Présent",
    "path.crm.percent": "{p} % terminé",
    "path.crm.enrolled": "Inscrit le {date}",
    "path.crm.lastActive": "Dernière activité : {when}",
    "path.crm.completedOn": "Terminé le {date}",
    "path.crm.certificate": "Certificat {code}",
    "path.crm.quizOne": "Meilleur score {best} % · {n} tentative",
    "path.crm.quiz": "Meilleur score {best} % · {n} tentatives",
    "path.crm.state.completed": "Terminée",
    "path.crm.state.available": "Pas encore faite",
    "path.crm.state.locked": "Verrouillée",
  },
  en: {
    // ── dashboard ──
    "path.dash.export": "Export",
    "path.dash.exportFailed": "The export could not be downloaded.",
    "path.dash.summary": "Summary",
    "path.dash.total.enrolled": "Enrolled",
    "path.dash.total.active_this_week": "Active this week",
    "path.dash.total.completed": "Completed",
    "path.dash.total.average_progress": "Average progress",
    "path.dash.total.stuck": "Stuck (14+ days)",
    "path.dash.funnel": "Step funnel",
    "path.dash.funnelEmpty": "Add steps to see where learners stop.",
    "path.dash.funnelSrOne": "{n} learner",
    "path.dash.funnelSr": "{n} learners",
    "path.dash.funnelDropSrOne": "{n} learner, the largest drop",
    "path.dash.funnelDropSr": "{n} learners, the largest drop",
    "path.dash.enrolled": "Enrolled",
    "path.dash.learners": "Learners",
    "path.dash.filter": "Filter learners",
    "path.dash.filterAll": "All learners",
    "path.dash.filterStuck": "Stuck · {n}",
    "path.dash.encourage": "Send encouragement",
    "path.dash.noLearners": "No learners here yet.",
    "path.dash.col.name": "Name",
    "path.dash.col.step": "Current step",
    "path.dash.col.progress": "Progress",
    "path.dash.col.lastActive": "Last active",
    "path.dash.col.quiz": "Quiz avg",
    "path.dash.completed": "Completed",
    "path.dash.progressOf": "Progress of {name}",
    "path.dash.rowHint": "Click a row to open the CRM record, Pathways tab, with the full step history.",
    "path.review.title": "Review queue · {n}",
    "path.review.empty": "No submission waiting.",
    "path.review.who": "{name} · {step}",
    "path.review.quote": "“{text}”",
    "path.review.photoAlt": "Photo submitted by {name}",
    "path.review.approve": "Approve",
    "path.review.sendFeedback": "Send feedback",
    "path.review.approved": "{name}'s submission approved",
    "path.review.feedbackSent": "Feedback sent to {name}",
    "path.review.feedbackTitle": "Feedback to {name}",
    "path.review.feedbackHint": "On “{step}”. Your message is emailed and shown on the step; the step stays done.",
    "path.review.feedbackMessage": "Message",
    "path.review.feedbackEmpty": "Write a message before sending.",
    "path.review.feedbackSend": "Send feedback",
    "path.attendance.title": "Attendance · {title} · {when}",
    "path.attendance.titleNoTime": "Attendance · {title}",
    "path.attendance.hint": "After the session, tick who attended: that completes the step. Unticking removes the mark but never undoes a completed step.",
    "path.attendance.save": "Save attendance",
    "path.attendance.saved": "Attendance saved",
    "path.dash.encourageTitle": "Send encouragement",
    "path.dash.encourageToOne": "To {n} stuck learner: {names}",
    "path.dash.encourageTo": "To {n} stuck learners: {names}",
    "path.dash.encourageMessage": "Message",
    "path.dash.encourageDefault": "Hi,\n\nIt's been a little while! Your next step is waiting for you: pick up where you left off, at your own pace. I'm here if you have any questions.",
    "path.dash.encourageEmpty": "Write a message before sending.",
    "path.dash.encourageSend": "Send to {n}",
    "path.dash.encourageSentOne": "Encouragement sent to {n} learner.",
    "path.dash.encourageSent": "Encouragement sent to {n} learners.",
    "path.dash.encourageSentSkipped": "Encouragement sent: {sent}. Skipped: {skipped} (no longer enrolled or already finished).",

    // ── weekly prompts ──
    "path.prompts.title": "Weekly prompts",
    "path.prompts.hint": "Posted on every member's pathway page and emailed to those who accept them.",
    "path.prompts.label": "New prompt",
    "path.prompts.placeholder": "e.g. This week, notice your breath before each practice…",
    "path.prompts.post": "Post",
    "path.prompts.empty": "Write the prompt before posting it.",
    "path.prompts.none": "No prompts posted yet.",
    "path.prompts.week": "Week {n}",

    // ── preview ──
    "path.preview.banner": "Learner preview: everything is unlocked, and nothing is recorded.",
    "path.preview.back": "Back to the builder",

    // ── CRM contact ──
    "path.crm.tabs": "Contact details",
    "path.crm.tab": "Pathways",
    "path.crm.empty": "This contact is not enrolled in any pathway.",
    "path.crm.submission.pending": "Submitted {date} · awaiting review",
    "path.crm.submission.approved": "Submitted {date} · approved",
    "path.crm.submission.feedback_sent": "Submitted {date} · feedback sent",
    "path.crm.submission.superseded": "Submitted {date} · replaced",
    "path.crm.attended": "Attended",
    "path.crm.percent": "{p}% complete",
    "path.crm.enrolled": "Enrolled {date}",
    "path.crm.lastActive": "Last active: {when}",
    "path.crm.completedOn": "Completed {date}",
    "path.crm.certificate": "Certificate {code}",
    "path.crm.quizOne": "Best score {best}% · {n} attempt",
    "path.crm.quiz": "Best score {best}% · {n} attempts",
    "path.crm.state.completed": "Completed",
    "path.crm.state.available": "Not done yet",
    "path.crm.state.locked": "Locked",
  },
  es: {
    // ── dashboard ──
    "path.dash.export": "Exportar",
    "path.dash.exportFailed": "No se pudo descargar la exportación.",
    "path.dash.summary": "Resumen",
    "path.dash.total.enrolled": "Inscritos",
    "path.dash.total.active_this_week": "Activos esta semana",
    "path.dash.total.completed": "Completado",
    "path.dash.total.average_progress": "Progreso medio",
    "path.dash.total.stuck": "Estancados (14+ días)",
    "path.dash.funnel": "Embudo de pasos",
    "path.dash.funnelEmpty": "Añade pasos para ver dónde se detienen los alumnos.",
    "path.dash.funnelSrOne": "{n} alumno",
    "path.dash.funnelSr": "{n} alumnos",
    "path.dash.funnelDropSrOne": "{n} alumno, la mayor caída",
    "path.dash.funnelDropSr": "{n} alumnos, la mayor caída",
    "path.dash.enrolled": "Inscritos",
    "path.dash.learners": "Alumnos",
    "path.dash.filter": "Filtrar alumnos",
    "path.dash.filterAll": "Todos los alumnos",
    "path.dash.filterStuck": "Estancados · {n}",
    "path.dash.encourage": "Enviar ánimo",
    "path.dash.noLearners": "Todavía no hay alumnos aquí.",
    "path.dash.col.name": "Nombre",
    "path.dash.col.step": "Paso actual",
    "path.dash.col.progress": "Progreso",
    "path.dash.col.lastActive": "Última actividad",
    "path.dash.col.quiz": "Media de cuestionarios",
    "path.dash.completed": "Completado",
    "path.dash.progressOf": "Progreso de {name}",
    "path.dash.rowHint": "Haz clic en una fila para abrir la ficha del CRM, pestaña Itinerarios, con todo el historial de pasos.",
    "path.review.title": "Cola de revisión · {n}",
    "path.review.empty": "Ningún envío pendiente.",
    "path.review.who": "{name} · {step}",
    "path.review.quote": "«{text}»",
    "path.review.photoAlt": "Foto enviada por {name}",
    "path.review.approve": "Aprobar",
    "path.review.sendFeedback": "Enviar comentarios",
    "path.review.approved": "Envío de {name} aprobado",
    "path.review.feedbackSent": "Comentarios enviados a {name}",
    "path.review.feedbackTitle": "Comentarios para {name}",
    "path.review.feedbackHint": "Sobre «{step}». Tu mensaje se envía por correo y se muestra en el paso; el paso sigue completado.",
    "path.review.feedbackMessage": "Mensaje",
    "path.review.feedbackEmpty": "Escribe un mensaje antes de enviar.",
    "path.review.feedbackSend": "Enviar comentarios",
    "path.attendance.title": "Asistencia · {title} · {when}",
    "path.attendance.titleNoTime": "Asistencia · {title}",
    "path.attendance.hint": "Después de la sesión, marca quién asistió: eso completa el paso. Desmarcar quita la asistencia, pero nunca deshace un paso completado.",
    "path.attendance.save": "Guardar asistencia",
    "path.attendance.saved": "Asistencia guardada",
    "path.dash.encourageTitle": "Enviar ánimo",
    "path.dash.encourageToOne": "A {n} alumno estancado: {names}",
    "path.dash.encourageTo": "A {n} alumnos estancados: {names}",
    "path.dash.encourageMessage": "Mensaje",
    "path.dash.encourageDefault": "Hola:\n\n¡Ha pasado un tiempo! Tu siguiente paso te espera: retoma donde lo dejaste, a tu ritmo. Estoy aquí si tienes cualquier pregunta.",
    "path.dash.encourageEmpty": "Escribe un mensaje antes de enviar.",
    "path.dash.encourageSend": "Enviar a {n}",
    "path.dash.encourageSentOne": "Ánimo enviado a {n} alumno.",
    "path.dash.encourageSent": "Ánimo enviado a {n} alumnos.",
    "path.dash.encourageSentSkipped": "Ánimo enviado: {sent}. Omitidos: {skipped} (ya no inscritos o ya terminado).",

    // ── weekly prompts ──
    "path.prompts.title": "Mensajes semanales",
    "path.prompts.hint": "Se publican en la página del itinerario de cada miembro y se envían por correo a quienes los aceptan.",
    "path.prompts.label": "Nuevo mensaje",
    "path.prompts.placeholder": "Ej.: Esta semana, observa tu respiración antes de cada práctica…",
    "path.prompts.post": "Publicar",
    "path.prompts.empty": "Escribe el mensaje antes de publicarlo.",
    "path.prompts.none": "Todavía no se ha publicado ningún mensaje.",
    "path.prompts.week": "Semana {n}",

    // ── preview ──
    "path.preview.banner": "Vista del alumno: todo está desbloqueado y no se registra nada.",
    "path.preview.back": "Volver a la creación",

    // ── CRM contact ──
    "path.crm.tabs": "Detalles del contacto",
    "path.crm.tab": "Itinerarios",
    "path.crm.empty": "Este contacto no está inscrito en ningún itinerario.",
    "path.crm.submission.pending": "Enviado el {date} · pendiente de revisión",
    "path.crm.submission.approved": "Enviado el {date} · aprobado",
    "path.crm.submission.feedback_sent": "Enviado el {date} · comentarios enviados",
    "path.crm.submission.superseded": "Enviado el {date} · reemplazado",
    "path.crm.attended": "Asistió",
    "path.crm.percent": "{p} % completado",
    "path.crm.enrolled": "Inscrito el {date}",
    "path.crm.lastActive": "Última actividad: {when}",
    "path.crm.completedOn": "Completado el {date}",
    "path.crm.certificate": "Certificado {code}",
    "path.crm.quizOne": "Mejor puntuación {best} % · {n} intento",
    "path.crm.quiz": "Mejor puntuación {best} % · {n} intentos",
    "path.crm.state.completed": "Completado",
    "path.crm.state.available": "Aún sin hacer",
    "path.crm.state.locked": "Bloqueado",
  },
};
